import CustomTable from "../../../shared/custom-table/CustomTable";
import React, {FC, useMemo} from "react";
import useWinnersTable from "./useWinnersTable";
import {IWinnerTicket, IWish} from "../../../../store/wish/Helper";
import {RootState, useAppSelector} from "../../../../store";
import {getActiveWinners} from "../../../../util/utils";
import WinnerRow from "./WinnerRow";

interface Props {
    wish: IWish;
    winners: IWinnerTicket[]
}

const WinnersTable: FC<Props> = (props) => {
    const {headCells} = useWinnersTable()
    const email = useAppSelector((state: RootState) => state.authReducer.loggedInUser.email)

    const activeWinners = useMemo(
        () => getActiveWinners(props.winners, props.wish.winners),
        [props.winners, props.wish.winners]
    )

    const tableRows = useMemo(() => activeWinners.map((winner, idx) => (
        <WinnerRow
            key={winner?.ticket?.id ?? `winner-${props.wish.id}-${idx}`}
            winner={winner}
            wishId={props.wish.id}
            userEmail={email}
        />
    )), [activeWinners, props.wish.id, email])

    return (
        <CustomTable
            headCells={headCells}
            tableBody={tableRows}
            count={tableRows.length}
            loading={false}
            noPagination
            transparent
        />
    )
}

export default WinnersTable
